import { apiPost } from '../../api'

export const save_payment = data => {
  return apiPost({
    endpoint: 'payments/save_payment',
    data: data
  })
}
